import { Check } from "lucide-react";

import { confirmMessage, confirmState } from "@/lib/confirm-password";

export const ConfirmNote = ({
  confirm,
  id,
  password,
  submitted,
}: {
  confirm: string;
  id: string;
  password: string;
  submitted: boolean;
}) => {
  const state = confirmState(password, confirm, submitted);
  const message = confirmMessage(password, confirm, submitted);
  if (!(message && state !== "idle")) {
    return null;
  }
  if (state === "match") {
    return (
      <p
        className="m-0 flex items-center gap-2 text-sm text-success leading-[1.45]"
        id={id}
      >
        <Check aria-hidden className="shrink-0" size={16} strokeWidth={2} />
        <span>{message}</span>
      </p>
    );
  }
  return (
    <p className="m-0 text-error text-sm leading-[1.45]" id={id} role="alert">
      {message}
    </p>
  );
};
